module.exports = __webpack_public_path__ + "static/media/qx.69fc69c0.jpg";